import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import WhyUsPage from './pages/WhyUsPage';
import EngagementPage from './pages/EngagementPage';
import ContactPage from './pages/ContactPage';

function App() {
  useEffect(() => {
    const initEmailJS = async () => {
      try {
        const emailjs = (await import('@emailjs/browser')).default;
        emailjs.init('wtAqmUvZdf-2ZdHQP');
      } catch (error) {
        console.error('Failed to initialize EmailJS:', error);
      }
    };
    initEmailJS();
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/why-us" element={<WhyUsPage />} />
          <Route path="/engagement" element={<EngagementPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;